import type { TutorCategoryType } from '@entities/tutor'

import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { usePaymentPoliciesStore } from '../../model/payment-policy/store'

interface SyncPolicyTutor {
  id: number
}

interface SyncPolicyItem {
  id: number | null
  category: TutorCategoryType
  reason: string
}

export interface SyncPoliciesPayload {
  tutors: SyncPolicyTutor[]
  tutor_payment_policies: SyncPolicyItem[]
}

interface SyncPoliciesApiOptions {
  payload: SyncPoliciesPayload
  onStart?: () => void
  onSuccess?: () => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

export const useSyncPoliciesApi = async (options: SyncPoliciesApiOptions): Promise<boolean> => {
  const { $axios } = useNuxtApp()

  const url = useAdminRoutes('admin.tutors.sync-policies')

  const paymentPoliciesStore = usePaymentPoliciesStore()
  const toast = useToast()

  options.onStart?.()
  paymentPoliciesStore.setLoading(true)

  try {
    await $axios.post(url!, options.payload)
    paymentPoliciesStore.setLoading(false)
    toast.success('Payment policies updated successfully')

    options.onSuccess?.()

    return true
  } catch (err: unknown) {
    console.error(err)
    paymentPoliciesStore.setLoading(false)
    toast.error('Failed to update payment policies')
    options.onError?.(err)

    return false
  } finally {
    options.onFinish?.()
  }
}
